import React from 'react';

class Map extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deliveryCity: props.delivery_city,
      deliveryCountry: props.delivery_country,
      companyCity: props.company_city,
      deliveryZip: props.delivery_zip,
      companyZip: props.company_zip,
      cities: props.cities,
      delivered: props.delivered
    };
  }

  initializeMap(centerLat, centerLon) {
    const map = new window.L.Map('myMap', {
      center: new window.L.LatLng(centerLat, centerLon),
      zoom: 6,
    });

    window.map = map;

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
    }).addTo(map);
  }

  mapMarkers() {
    const { deliveryCity, deliveryCountry, companyCity, companyZip, deliveryZip } = this.state;

    window.map.eachLayer(function (layer) {
      if (layer instanceof window.L.Marker || layer instanceof window.L.Polyline) {
        window.map.removeLayer(layer);
      }
    });

    const geocode = async ({ city, zip, country }) => {
      const params = new URLSearchParams({
        format: 'jsonv2',
        addressdetails: '1',
        limit: '10',
      });
      if (city) params.set('city', city);
      if (zip) params.set('postalcode', zip);
      if (country) params.set('country', country);
      const url = `https://nominatim.openstreetmap.org/search?${params.toString()}`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          const normalizedCity = (city || '').trim().toLowerCase();
          const normalizedZip = (zip || '').trim();
          const normalizedCountry = (country || '').trim().toLowerCase();
          const matchesCity = (entry) => {
            const address = entry.address || {};
            const cityName =
              address.city ||
              address.town ||
              address.village ||
              address.hamlet ||
              address.municipality ||
              '';
            return cityName.trim().toLowerCase() === normalizedCity;
          };
          const matchesZip = (entry) => {
            const address = entry.address || {};
            return (address.postcode || '').trim() === normalizedZip;
          };
          const matchesCountry = (entry) => {
            if (!normalizedCountry) return true;
            const address = entry.address || {};
            const countryName = (address.country || '').trim().toLowerCase();
            const countryCode = (address.country_code || '').trim().toLowerCase();
            const displayName = (entry.display_name || '').toLowerCase();
            return (
              countryName === normalizedCountry ||
              countryCode === normalizedCountry ||
              displayName.includes(normalizedCountry)
            );
          };

          const bestMatch =
            data.find((entry) => matchesCity(entry) && matchesZip(entry) && matchesCountry(entry)) ||
            data.find((entry) => matchesCity(entry) && matchesCountry(entry)) ||
            data.find((entry) => matchesZip(entry) && matchesCountry(entry)) ||
            data.find((entry) => matchesCity(entry) && matchesZip(entry)) ||
            data.find((entry) => matchesCity(entry)) ||
            data.find((entry) => matchesZip(entry)) ||
            data.find((entry) => matchesCountry(entry)) ||
            data[0];

          return { lat: parseFloat(bestMatch.lat), lon: parseFloat(bestMatch.lon) };
        } else {
          console.warn(`No results found for ${city} ${zip}`);
          return null;
        }
      } catch (error) {
        console.error(`Failed to fetch geocode for ${city} ${zip}:`, error);
        return null;
      }
    };

    const addMarker = (lat, lon, color) => {
      return window.L.circleMarker([lat, lon], {
        color: color,
        radius: 8,
      }).addTo(window.map);
    };

    Promise.all([
      geocode({ city: deliveryCity, zip: deliveryZip, country: deliveryCountry }),
      geocode({ city: companyCity, zip: companyZip })
    ]).then(([fromLocation, toLocation]) => {
      if (fromLocation) {
        addMarker(fromLocation.lat, fromLocation.lon, '#00dc1b');
      } else {
        console.error('Failed to geocode the delivery address.');
      }

      if (toLocation) {
        addMarker(toLocation.lat, toLocation.lon, 'red');
      } else {
        console.error('Failed to geocode the company address.');
      }

      if (fromLocation && toLocation) {
        window.L.polyline([
          [fromLocation.lat, fromLocation.lon],
          [toLocation.lat, toLocation.lon]
        ], { color: 'blue', weight: 3 }).addTo(window.map);

        const bounds = window.L.latLngBounds([
          [fromLocation.lat, fromLocation.lon],
          [toLocation.lat, toLocation.lon],
        ]);
        window.map.fitBounds(bounds);
      }
    });
  }

  loadScript(url, callback) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = url;

    script.onload = callback;

    document.getElementsByTagName('head')[0].appendChild(script);
  }

  componentDidMount() {
    // Leaflet
    const scriptURL = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
    const self = this;

    if (document.querySelector(`script[src="${scriptURL}"]`) === null) {
      this.loadScript(scriptURL, function () {
        self.initializeMap(51.9061197, 19.4204499); // Center - Poland by default
        self.mapMarkers();
      });

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.delivery_city !== this.props.delivery_city ||
      prevProps.delivery_zip !== this.props.delivery_zip ||
      prevProps.delivery_country !== this.props.delivery_country ||
      prevProps.company_city !== this.props.company_city ||
      prevProps.company_zip !== this.props.company_zip
    ) {
      this.setState({
        deliveryCity: this.props.delivery_city,
        deliveryZip: this.props.delivery_zip,
        deliveryCountry: this.props.delivery_country,
        companyCity: this.props.company_city,
        companyZip: this.props.company_zip
      }, () => {
        this.mapMarkers();
      });
    }
  }

  render() {
    return <div id="myMap" style={{ width: '100%', height: '500px' }}></div>;
  }
}

export default Map;
